import styled from '@emotion/styled'

/* https://codepen.io/scottloway/pen/zqoLyQ */

const CheckmarkView = styled.span<{ bgColor?: string }>`
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 1.9rem;
  height: 1.9rem;
  border-width: 0.2rem;
  border-style: solid;
  border-color: ${(props) => props.bgColor || props.theme.success.bgColor};
  background-color: ${(props) => props.bgColor || props.theme.success.bgColor};
`

const CheckmarkTick = styled.span<{ color?: string }>`
  display: block;

  &:after {
    position: absolute;
    left: 0.2rem;
    top: 0.8rem;
    height: 1rem;
    width: 0.5rem;
    border-right: 0.2rem solid
      ${(props) => props.color || props.theme.success.color};
    border-top: 0.2rem solid
      ${(props) => props.color || props.theme.success.color};
    content: '';
    opacity: 1;
    transform-origin: left top;
    transform: scaleX(-1) rotate(135deg);
  }
`

const Checkmark = ({
  color,
  bgColor,
}: {
  color?: string
  bgColor?: string
}) => {
  return (
    <CheckmarkView color={color} bgColor={bgColor}>
      <CheckmarkTick />
    </CheckmarkView>
  )
}

export default Checkmark
